export default __webpack_public_path__ + "static/media/guessmynumber2.7e2d3951.png";